import React, { useCallback } from 'react';
import Shimmer from 'sushiweb/Shimmer';
import Tag from 'sushiweb/Tag';
import { Table } from '../../../UiKit';
import ReactJson from 'react-json-view';
import { convertToReadableDate } from '../../../utils/UtilFunctions';

const tableHeadings = [
  { name: 'Tag', key: 1 },
  { name: 'Issue Details', key: 2 },
  { name: 'Added by', key: 3 },
  { name: 'Agent Role', key: 4 },
];

export const TagsDetails = ({ tags }) => {
  const getIssueDetails = useCallback((details) => {
    if (Object.keys(details)?.length === 0) return '-';
    return (
      <ReactJson
        src={details}
        name={false}
        displayDataTypes={false}
        displayObjectSize={false}
        enableClipboard={false}
        collapsed={true}
      />
    );
  }, []);

  const getTagsInfoRows = useCallback(
    (tags) => {
      const rowsData = [];
      tags &&
        tags.map((tag) => {
          const tagAddedDate = convertToReadableDate(tag?.timestamp);

          const tagObj = {
            1: {
              title: (
                <Tag
                  type='tag'
                  label={tag.title}
                  bgColor={tag.type === 'auto' ? '#F6F9FD' : '#F8F8F8'}
                  textColor={tag.type === 'auto' ? '#0366D6' : '##828282'}
                />
              ),
            },
            2: {
              title:
                typeof tag.issue_details === 'object'
                  ? getIssueDetails(tag.issue_details)
                  : '_',
            },
            3: {
              title: tag.added_by || '-',
              subtitle: tagAddedDate || '-',
            },
            4: {
              title: tag.agent_role || '-',
            },
          };
          rowsData.push(tagObj);
          return true;
        });
      return rowsData;
    },
    [getIssueDetails],
  );

  const getTableData = useCallback(
    (tags) => {
      if (!tags) return null;
      const tableData = {
        headings: tableHeadings,
        rows: getTagsInfoRows(tags),
      };
      return tableData;
    },
    [getTagsInfoRows],
  );

  return (
    <div className='modalContent' data-dd-privacy='mask'>
      {!tags ? (
        <Shimmer height='300px' width='100%' />
      ) : (
        <Table tableData={getTableData(tags)} />
      )}
    </div>
  );
};
